import React, { useState } from "react";
import styled from "styled-components";
import { Table } from "rsuite";
import { useFormikContext } from "formik";
import AddUserTable from "../../global/components/Tables/AddUserTable";
import { useLocation } from "react-router-dom";
import { device } from "../../styles/breakpoints";

const AddUsersDescription = styled.div`
  /* Mobile-first: readable description text */
  font-family: Verizon-NHG-eDS;
  font-size: 14px;
  margin-left: 0;
  margin-bottom: 16px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-align: left;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
    margin-left: 1%;
  }
`;

const WrapperForTable = styled.div`
  /* Mobile-first: flexible table container */
  margin-top: 15px;
  width: 100%;
  height: auto;
  flex-grow: 1;
  display: block;
  overflow: visible; /* Allow horizontal scroll from inner wrapper */

  @media ${device.tablet} {
    height: 60%;
    max-height: 100vh;
  }
`;

const AddUsersContainer = styled.div`
  /* Mobile-first: full width with proper overflow */
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;

  @media ${device.tablet} {
    padding-right: 15px;
  }
`;

function AddUsers({ isEditable, setUserInfo }) {
  const location = useLocation();
  const mode = location.state?.mode || "add";
  const [fetchError, setFetchError] = useState(false);

  const handleFetchError = (hasError) => {
    setFetchError(hasError);
  };

  return (
    <AddUsersContainer id="editUsers">
      {mode === "add" && !isEditable && !fetchError && (
        <AddUsersDescription>
          Select all the users within your organization that should have access
          to this site.
        </AddUsersDescription>
      )}
      <WrapperForTable>
        <AddUserTable
          isEditable={isEditable}
          setUserInfo={setUserInfo}
          onFetchError={handleFetchError}
        />
      </WrapperForTable>
    </AddUsersContainer>
  );
}

export default AddUsers;
